export const archiveConstants = {
    UNSPLASH: 'UNSPLASH',
    FONT: 'FONT',
    IMAGE: 'IMAGE',
    GRID: 'GRID',
    OTHER: 'OTHER',
    LIST: 'LIST',

    OTHER_TYPES: [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx'
    ],
    IMAGE_TYPES: [
        'jpeg',
        'png',
        'gif',
        'svg+xml'
    ],
    FONT_TYPES: [
        "abf",
        "acfm",
        "afm",
        "amfm",
        "bdf",
        "cha",
        "chr",
        "compositefont",
        "dfont",
        "eot",
        "etx",
        "euf",
        "f3f",
        "fea",
        "ffil",
        "fnt",
        "fon",
        "fot",
        "gdr",
        "gf",
        "glif",
        "gxf",
        "lwfn",
        "mcf",
        "mf",
        "mxf",
        "nftr",
        "odttf",
        "otf",
        "pcf",
        "pfa",
        "pfb",
        "pfm",
        "pfr",
        "pk",
        "pmt",
        "sfd",
        "sfp",
        "suit",
        "t65",
        "tfm",
        "ttc",
        "tte",
        "ttf",
        "txf",
        "ufo",
        "vfb",
        "vlw",
        "vnf",
        "woff",
        "woff2",
        "xfn",
        "xft",
        "ytf",
    ]

}